module.exports = __webpack_public_path__ + "img/Screenshot_2021-10-28-16-14-28-786_com.pinkcoffee.sexbattle.ab454de3.jpg";